import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as Wave } from "../../../../assets/img/background/wave.svg";
import { ReactComponent as CloseIcon } from "../../../../assets/img/icon/close_black_24dp.svg";
import { ReactComponent as Dashboard } from "../../../../assets/img/icon/dashboard_black_24dpt.svg";
import { ReactComponent as Description } from "../../../../assets/img/icon/description_black_24dpt.svg";
import { ReactComponent as MaskIcon } from "../../../../assets/img/icon/masks_black_24dpt.svg";
import { ReactComponent as People } from "../../../../assets/img/icon/people_black_24dpt.svg";
import { ReactComponent as Person } from "../../../../assets/img/icon/person_black_24dpt.svg";
import logo from "../../../../assets/img/logo/logomd.png";
import { cleanUpdateTokenJob } from "../../../../services/httpService/loginRequest";
import { GlobalContext } from "../../../contexts/globalContext";
import Backdrop from "../../atoms/Backdrop/Backdrop";

const iconStyle = "w-7 h-7 mx-auto fill-current";

const PAGE_LIST = [
  {
    label: "dashboard",
    icon: <Dashboard className={iconStyle} />,
    path: "/",
  },
  {
    label: "pasien",
    icon: <People className={iconStyle} />,
    path: "/patient",
  },
  {
    label: "rekam",
    icon: <Description className={iconStyle} />,
    path: "/record",
  },
  {
    label: "perangkat",
    icon: <MaskIcon className={iconStyle} />,
    path: "/device",
  },

  {
    label: "profil",
    icon: <Person className={iconStyle} />,
    path: "/profile",
  },
];

const OTHERS = [
  {
    label: "tentang aplikasi",
    path: "/about",
  },
  {
    label: "faq",
    path: "/faq",
  },
];

const Sidebar = (props) => {
  const [sharedState, dispatch] = useContext(GlobalContext);
  const history = useHistory();
  const { user } = sharedState;

  const handleConfirmLogout = () => {
    props.sidebarToggler();
    dispatch("confirm", {
      show: true,
      message: "Anda yakin akan keluar dari aplikasi respinos?",
      callback: () => {
        dispatch("confirm", { show: false });
        dispatch("isLoading", true);
        setTimeout(() => {
          sessionStorage.clear();
          dispatch("user", {
            _id: "",
            token: "",
            isLogin: false,
            email: "",
            name: "",
            profile: "",
            role: "",
          });
          dispatch("isLoading", false);
          history.push("/login");
          cleanUpdateTokenJob();
        }, 500);
      },
    });
  };

  return (
    <>
      {props.showSidebar && <Backdrop />}
      <div
        className={
          "w-full max-w-md fixed right-0 top-0 bottom-0 bg-white z-40 text-sm transition-all ease-in-out duration-300 pb-24 "
        }
        style={{
          marginRight: props.showSidebar ? "0" : "-60rem",
        }}
      >
        <div className="px-4 py-2 flex justify-between items-center border-b border-primary border-opacity-60">
          <div className="bg-white py-2 rounded-md">
            <img src={logo} alt="" className="h-8 flex-shrink-0" />
          </div>
          <div className="cursor-pointer" onClick={props.sidebarToggler}>
            <CloseIcon className="w-6 h-6 fill-current text-gray-500" />
          </div>
        </div>
        <Wave className="w-full h-auto absolute" />
        <div className="my-4 px-2">
          <div className="px-3 py-3 border bg-primary text-white border-white rounded-md">
            <div className="flex space-x-4 items-center relative">
              <div>
                <img
                  src={user.profile.avatar}
                  alt=""
                  className="w-16 h-16 rounded-full bg-white"
                />
              </div>
              <div>
                <div className="font-semibold text-base">{user.name}</div>
                <div className="text-xs mt-0.5">{user.email}</div>
              </div>

              <div
                className="absolute cursor-pointer top-0 right-0 border border-white bg-white bg-opacity-20 text-white rounded-lg px-2 py-1"
                onClick={handleConfirmLogout}
              >
                Keluar
              </div>
            </div>
            <p className="mt-1 text-white text-opacity-70">
              {sharedState.user.profile.description || "Belum ada deskripsi."}
            </p>
          </div>
        </div>
        <div className="mt-5 px-3">
          <div className="font-semibold">Menu Utama</div>
          <div className="mt-2 grid grid-cols-3 gap-2.5">
            {PAGE_LIST.map((page, idx) => (
              <div
                className={
                  "p-2 capitalize text-center border border-primary text-primary bg-primary bg-opacity-20 rounded cursor-pointer " +
                  (idx === 0 ? "border-t" : "")
                }
                key={"sidebar-page-" + page.label}
                onClick={() => {
                  history.push(`${page.path}`);
                  props.sidebarToggler();
                }}
              >
                <div>{page.icon}</div>
                <div>{page.label}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-3 px-3">
          <div className="font-semibold">Lain-lain</div>
          <div className="mt-2 grid grid-cols-3 gap-2.5">
            {OTHERS.map((page, idx) => (
              <div
                className={
                  "p-2 capitalize text-center border border-primary text-primary bg-primary bg-opacity-20 rounded cursor-pointer flex flex-col justify-center " +
                  (idx === 0 ? "border-t" : "")
                }
                key={"other-sidebar-page-" + page.label}
                onClick={() => {
                  history.push(page.path);
                  props.sidebarToggler();
                }}
              >
                <div>{page.label}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="text-xs md:text-sm text-center absolute bottom-3 inset-x-0">
          <p>Copyright &copy; 2021</p>
          <p>PT. Xirka Dama Persada</p>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
